export default __webpack_public_path__ + "static/media/balloon.3b56ce15.png";